import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const saveCallDurationApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction(data,apiConstants.VIDEO.SAVE_CALL_DURATION)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
